<template>
	<SignUpPageBase :content="this">
		<img class="margin_bottom" :src="logo" style="width:160px;height: 40px" aria-hidden="true" alt=""/>
		<span class="margin_title_bottom">{{ $t("signUp.start.intro") }}</span>
		<span class="font_bold margin_vertical">{{ $t("signUp.language.title") }}</span>
		<form class="flex flex_center flex_column w_100">
			<LanguageSelect style="max-width: 300px"
				:label-text="$t('common.language')"
				v-model="form.language"
				@input="setLanguage(form.language)"
				v-validate="modelValidations.language"
				data-vv-name="language"
				:error="errors.first('language')"
				required
			></LanguageSelect>
		</form>
	</SignUpPageBase>
</template>

<script>
import SignUpPageBase from "@/views/register/SignUpPageBase";
import {localization} from "@/common/lang/localization";
import logo from "@/assets/img/logo_tnp_dark.svg";
import LanguageSelect from "@/components/templates/select/LanguageSelect";

export default {
	components: {
		LanguageSelect,
		SignUpPageBase,
	},
	data() {
		return {
			form: {
				language: localization.currentLang()
			},
			modelValidations: {
				language: { required: true }
			},
			logo: logo
		};
	},
};
</script>